const classesHotspots = {
  hide: 'hide',
  open: 'is-open',
  autoHeight: 'hotspot-autoheight',
  overlay_bg: 'overlay-bg'
};

register('hp-hotspots', {
  onLoad() {
    const hotspot_triggers = this.container.querySelectorAll('.hp-hotspot__trigger'),
          hotspot_close = this.container.querySelectorAll('.hotspot-close'),
          hotspot_image = this.container.querySelector('.hp-hotspots__background'),
          hotspot_modal = this.container.querySelector('.hp-hotspot-modal'),
          hotspot_modal_wrapper = hotspot_modal.closest('.hp-hotspots-wrapper'),
          hotspot_content = this.container.querySelector('.hp-hotspot__content'),
          body = document.querySelector('body');

    hotspot_triggers.forEach(trigger => {

      let offset = trigger.dataset.offset;
      offset = offset.split(',');
      let width = parseInt(offset[0]);;
      let height = parseInt(offset[1]);
      let left_pos = parseInt(offset[2]);
      let top_pos = parseInt(offset[3]);
      
      let left_percent = 100* (left_pos/width).toFixed(2);
      let top_percent = 100* (top_pos/height).toFixed(2);
      //console.log(width,height,left_pos,top_pos);
      trigger.style.left = left_percent + '%';
      trigger.style.top = top_percent + '%';

      trigger.addEventListener('click', (e)=> {
        const product_handle = trigger.dataset.productHandle;
        fetch('products/' + product_handle + '?view=hotspot').then(function (response) {
          // The API call was successful!
          return response.text();
        }).then(function (html) {
          hotspot_content.innerHTML = html;
          hotspot_modal_wrapper.classList.add(classesHotspots.open);
          body.classList.add(classesHotspots.overlay_bg);
          const boundingRect = hotspot_modal_wrapper.getBoundingClientRect();
          if ( boundingRect.top < 0 ) {
            hotspot_modal_wrapper.style.marginTop = -1 * boundingRect.top + 'px';
          }else{
            hotspot_modal_wrapper.style.removeProperty('margin-top');
          }
        }).catch(function (err) {
          // There was an error
          console.warn('Something went wrong.', err);
        });
      })
    });
    hotspot_close.forEach( btn => {
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        hotspot_modal_wrapper.classList.remove(classesHotspots.open);
        hotspot_modal_wrapper.style.removeProperty('margin-top');
        //hotspot_image.style.removeProperty('height');
        body.classList.remove(classesHotspots.overlay_bg);
      })
    });
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});

load('hp-hotspots');